import React from "react";
import styled from "styled-components";
import Layout from "../components/layout";
import Seo from "../components/seo";
import { SectionWrapper } from "../components/common";

const ContactWrapper = styled(SectionWrapper)`
  padding: 1em 3em 5em;
  max-width: 100%;

  @media (min-width: 1200px) {
    padding: 1em 4em 5em;
  }

  @media (min-width: 1500px) {
    padding: 1em 6em 5em;
  }

  @media (max-width: 768px) {
    padding: 1em 1.5em 4em;
  }
`;

const PageTitle = styled.h2`
  background: ${({ theme }) => theme.colors.secondaryGradient};
  font-size: 48px;
  padding: 15px 0;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Lead = styled.p`
  margin-bottom: 2em;
  color: #cfcfcf;
`;

const ContactList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    font-size: 1.15em;
    line-height: 1.8em;
    margin-bottom: 0.4em;
  }

  .label {
    color: #888;
    display: inline-block;
    width: 90px;
  }

  a {
    color: #f2994a;
    text-decoration: none;
    font-weight: 600;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const ContactPage = () => {
  return (
    <Layout>
      <Seo
        title="Contact"
        description="Get in touch with Ayodeji Abodunrin — email, LinkedIn, and GitHub."
      />
      <ContactWrapper>
        <PageTitle>Contact</PageTitle>
        <Lead>
          Best way to reach me is by email. I'm always open to talking about
          payment systems, fraud detection, and engineering leadership.
        </Lead>
        <ContactList>
          <li>
            <span className="label">Email</span>
            <a href="mailto:aboayosam@gmail.com">aboayosam@gmail.com</a>
          </li>
          <li>
            <span className="label">LinkedIn</span>
            <a
              href="https://www.linkedin.com/in/abodunrinayodeji/"
              target="_blank"
              rel="noreferrer"
            >
              linkedin.com/in/abodunrinayodeji
            </a>
          </li>
          <li>
            <span className="label">GitHub</span>
            <a
              href="https://github.com/omob"
              target="_blank"
              rel="noreferrer"
            >
              github.com/omob
            </a>
          </li>
        </ContactList>
      </ContactWrapper>
    </Layout>
  );
};

export default ContactPage;
